import { HttpErrorResponse } from '@angular/common/http';

/** The backend's error envelope: `{ status, message, data, field_errors }`. */
export interface ApiErrorBody {
  status?: boolean | number;
  message?: string;
  data?: any;
  field_errors?: Record<string, string | string[]>;
}

/**
 * The backend's error body, whichever way the error reached the subscriber.
 *
 * `ApiService.post` / `put` / `patch` / `delete` rethrow the response body itself, while its cached GETs
 * rethrow the `HttpErrorResponse`, whose body sits under `.error`. Reading `err.error.message` therefore
 * finds nothing after a PUT, which is why a 422's message and `field_errors` never reached the screen.
 */
export function apiErrorBody(err: unknown): ApiErrorBody {
  if (err instanceof HttpErrorResponse) {
    return err.error && typeof err.error === 'object' ? err.error : {};
  }
  return err && typeof err === 'object' ? (err as ApiErrorBody) : {};
}
